<template>
  <div id="legalact" class="legalact" v-loading.body="loading">
    <el-form :model="currentLegalAct" :rules="legalActRules" ref="legalAct" label-width="180px">
      <el-form-item label="Краткое наименование" prop="label">
        <el-input placeholder="Введите краткое наименование..." v-model="currentLegalAct.label" style="width:50%;">
        </el-input>
      </el-form-item>
      <el-form-item label="Полное наименование" prop="fullLabel">
        <el-input placeholder="Введите полное наименование..." v-model="currentLegalAct.fullLabel">
        </el-input>
      </el-form-item>
      <el-form-item label="Тип" prop="type">
        <el-select v-model="currentLegalAct.type" placeholder="Выберите тип" style="width:50%;" filterable>
          <el-option
            v-for="item in types"
            :key="item.id"
            :label="item.label"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Уровень органа" prop="authorityLevel">
        <el-select v-model="currentLegalAct.authorityLevel" placeholder="Выберите уровень органа" style="width:25%;" filterable>
          <el-option
            v-for="item in authorityLevels"
            :key="item.id"
            :label="item.label"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Статус" prop="status">
        <el-select v-model="currentLegalAct.status" placeholder="Выберите статус" style="width:25%;" filterable>
          <el-option
            v-for="item in statuses"
            :key="item.id"
            :label="item.label"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Ссылка" prop="httpLink">
        <el-input placeholder="Введите ссылку..." v-model="currentLegalAct.httpLink">
        </el-input>
      </el-form-item>
      <el-form-item label="Дата начала действия" prop="dateStarted">
        <el-date-picker v-model="currentLegalAct.dateStarted" type="date" format="dd.MM.yyyy" placeholder="Выберите дату">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Дата последней редакции" prop="dateEdited">
        <el-date-picker v-model="currentLegalAct.dateEdited" type="date" format="dd.MM.yyyy" placeholder="Выберите дату">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Дата окончания действия" prop="dateFinished">
        <el-date-picker v-model="currentLegalAct.dateFinished" type="date" format="dd.MM.yyyy" placeholder="Выберите дату">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div style="padding:5px;">
      <el-button style="float:right;width:150px;height:36px;" type="danger" icon="close" @click="cancel">
        Отмена
      </el-button>
      <el-button style="float:right;width:150px;height:36px;margin-right:10px;" type="success" icon="edit" @click="save">
        Сохранить
      </el-button>
    </div>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'
  import grid from '../../api/helpers/grid'
  import rules from '../../api/rules/legalact'

  export default {
    name: 'legalact',
    props: ['la'],
    data() {
      return {
        loading: false,
        currentLegalAct: {
          uid: null,
          label: '',
          fullLabel: '',
          type: null,
          authorityLevel: null,
          status: null,
          dateStarted: null,
          dateEdited: null,
          dateFinished: null,
          httpLink: ''
        },
        types: [],
        authorityLevels: [],
        statuses: [],
        dateEdited: [
          {
            required: false, validator: (rule, value, callback) => {
              if(value) {
                if(this.currentLegalAct && this.currentLegalAct.dateStarted) {
                  let dateEdited = new Date(new Date(value).toDateString());
                  let dateStarted = new Date(this.currentLegalAct.dateStarted.toDateString());
                  if(dateStarted >= dateEdited)
                    return callback("Дата последней редакции должна быть больше даты начала действия");
                }
                return callback();
              }
            }, trigger: 'change'
          }
        ],
        dateFinished: [
          {
            required: false, validator: (rule, value, callback) => {
              if(value) {
                if(this.currentLegalAct && this.currentLegalAct.dateStarted) {
                  let dateEdited = new Date(new Date(value).toDateString());
                  let dateStarted = new Date(this.currentLegalAct.dateStarted.toDateString());
                  if(dateStarted >= dateEdited)
                    return callback("Дата окончания действия должна быть больше даты начала действия");
                }
              }
              return callback();
            }, trigger: 'change'
          }
        ]
      }
    },
    computed: {
      legalActRules: function() {
        let r = rules.getLegalActRules()
        r.dateEdited = this.dateEdited;
        r.dateFinished = this.dateFinished;
        return r;
      }
    },
    methods: {
      reset() {
        this.currentLegalAct = {
          uid: null,
          label: '',
          fullLabel: '',
          type: null,
          authorityLevel: null,
          status: null,
          dateStarted: null,
          dateEdited: null,
          dateFinished: null,
          httpLink: ''
        }
      },
      save() {
        this.$refs['legalAct'].validate((valid) => {
          if (valid) {
            if(this.currentLegalAct) {
              this.$gf.getOptions().then(options => {
                options.params = { };
                let self = this;
                let prefix = config.API_PREFIX;
                /*if(this.currentLegalAct.uid === '') {
                  self.$http.post(`${prefix}legalacts`, this.currentLegalAct, options).then(response => {
                      this.$router.push(config.LEGAL_ACTS_URL);
                  }).catch(data => {
                    this.loading = false;
                    self.$gf.checkError(data)
                  });
                } else {
                  self.$http.put(`${prefix}legalacts`, this.currentLegalAct, options).then(response => {
                      this.$router.push(config.LEGAL_ACTS_URL);
                  }).catch(data => {
                    this.loading = false;
                    self.$gf.checkError(data)
                  });
                }*/
              });
            }
          }
        });
      },
      cancel() {
        this.$confirm('Вы действительно хотите покинуть страницу? Изменения не будут учтены', 'Предупреждение', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(() => {
          this.$router.push(config.LEGAL_ACTS_URL);
        }).catch(() => {

        });
      },
      fetch(uid) {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///LEGAL ACT
          /*if(uid) {
            self.$http.get(`${prefix}legalacts/uid=${uid}`, options)
              .then(response => {
                self.currentLegalAct = response.data;
                self.loading = false;
              })
              .catch(data => {
                self.$gf.checkError(data);
                self.loading = false;
              });
            }*/
          ///COMBOS
          /*self.$http.get(`${prefix}legalacts/statuses`, options)
            .then(response => {
              self.statuses = response.data;
              self.loading = false;
            })
            .catch(data => {
              self.$gf.checkError(data);
              self.loading = false;
            });
            self.loading = true;
            self.$http.get(`${prefix}legalacts/types`, options)
              .then(response => {
                self.types = response.data;
                self.loading = false;
              })
              .catch(data => {
                self.$gf.checkError(data);
                self.loading = false;
              });
              self.loading = true;
              self.$http.get(`${prefix}legalacts/authorityLevels`, options)
                .then(response => {
                  self.authorityLevels = response.data;
                  self.loading = false;
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });*/
            self.loading = false;
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      resize() {
        let height = layout.getParentClientHeight();

      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    created() {
      window.addEventListener('resize', this.resize);
      this.fetch(this.la);
      if(!this.la)
        this.reset();
    }
  }

</script>

<style scoped>
  .legalact {
    height: calc(100% - 20px);
    border: 1px solid #d1dbe5;
    padding: 10px;
    overflow-y: scroll;
  }
</style>
<style>
  .el-table .cell {
    word-break: normal !important;
  }
  .el-picker-panel {
    min-width: 350px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/registry/legalact.vue